export const contentTableConfig = {
  title: '成交客户列表',
  propList: [
    {prop: 'name', label: '客户昵称', minWidth: '100', slotName: 'consumer', align: 'left'},
    {prop: 'unionid', label: '客户UnionId', minWidth: '80', slotName: 'unionid', align: 'left'},
    {prop: 'corpName', label: '所属主体', minWidth: '80', align: 'left'},
    {prop: 'createdAt', label: '加入时间', minWidth: '80', align: 'left', sortable: true},
    {prop: 'empId', label: '工作微信号', minWidth: '80', slotName: 'empId', align: 'left'},
    {prop: 'groupName', label: '组别', minWidth: '50', align: 'left'},
    {prop: 'description', label: '描述', minWidth: '80', slotName: 'description', align: 'left'},
    {prop: 'favoriteTeacher', label: '喜欢的老师', minWidth: '60', align: 'left'},
    {prop: 'sourceLabel', label: '来源渠道', minWidth: '80', align: 'left'},
    {prop: 'thirdParty', label: '渠道第三方', minWidth: '60', align: 'left'},
    {prop: 'succAmount', label: '成交金额', minWidth: '60', align: 'left', sortable: true},
    {prop: 'succTime', label: '成交时间', minWidth: '60', align: 'left', sortable: true}
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/userSucc/dataImport'
}
